// src/utils/addPropertyDraft.js
//
// In-memory draft store for AddPropertyPage.
//
// Why this exists: App.js registers /post/category, /post/district, and
// /post/division as separate top-level routes (not nested/overlay routes
// on top of /post/add-property). That means every time the user taps a
// picker field, React Router fully unmounts AddPropertyPage and mounts a
// fresh instance when navigating back — all local component state
// (selectedCategory, title, images, etc.) is lost, not just the field
// that was being picked.
//
// This mirrors what the Flutter version achieves for free via
// Navigator.push (the old page instance simply stays alive underneath):
// we keep a single, module-scoped object holding the full form state.
// AddPropertyPage reads from it on mount and writes to it on every
// change, so re-mounting after a picker trip restores everything exactly
// as it was. It only lives in memory for the current browser tab session
// (not sessionStorage/localStorage) — a full page refresh clears it,
// same as it would for any unsaved form.

const defaults = {
  title: '',
  description: '',
  price: '',
  address: '',
  phone: '',
  isNegotiable: false,
  selectedCategory: null,
  selectedSubcategory: null,
  selectedDistrict: null,
  selectedDivision: null,
  specificValues: {},
  images: [],
  videoFile: null,
  videoPreviewUrl: null,
  videoDuration: 0,
  thumbnailFile: null,
};

let draft = { ...defaults };

export function getAddPropertyDraft() {
  return draft;
}

export function updateAddPropertyDraft(patch) {
  draft = { ...draft, ...patch };
}

export function clearAddPropertyDraft() {
  draft = { ...defaults, images: [], specificValues: {} };
}